import * as form from '../form';

export const financialCard = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Agency: form.text(xitem.Agency),
        Address: form.location(xitem.Address),
        Date: form.datecontrol(xitem.Date),
        Reason: form.textarea(xitem.Reason),
        Amount: form.number(xitem.Amount),
        AmountEstimated: form.checkbox(xitem.AmountEstimated),
        Description: form.textarea(xitem.Description),
        WhenDisciplineReceived: form.datecontrol(xitem.WhenDisciplineReceived),
        ActionsTaken: form.checkboxgroup(xitem.ActionsTaken),
        DisciplinaryAction: form.checkboxgroup(xitem.DisciplinaryAction),
        DisciplinaryActionExplanation: form.textarea(xitem.DisciplinaryActionExplanation),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        AccountNum: form.text(xitem.AccountNum),
      },
    };
  });
  return {
    HasCardAbuse: form.branch(data.HasCardAbuse),
    List: form.collection(items, (data.List || {}).branch),
  };
};
